import { useContext } from 'react';
import AppContext from '../../AppContext';
import { getBreite, getHoehe, getLaenge, getTiefe, getNullableSelectedVariationWert, getSelectedVariationWert, sumAufpreise } from '../../utils/app-data';
import Preis from '../common/Preis';
import UnsafeHtml from '../common/UnsafeHtml';
import { calculatePrice } from '../../utils/price';

function Artikelpreis() {
  const { appData } = useContext(AppContext);

  const priceStartingAt = (
    <div>
      <span className="price_label pricestarting">ab </span>
      <div className="price h1">
        <span itemProp="priceSpecification" itemType="https://schema.org/UnitPriceSpecification">
          <UnsafeHtml unsafeHtml={appData.static.artikel.preise.cVKLocalized[0]} />
        </span>
      </div>
      <span className="price_label"> / m²</span>
    </div>
  );

  let priceArtikel: number;
  if (appData.static.config.productType === 'rolladen') {
    const breite = getBreite(appData);
    const hoehe = getHoehe(appData);
    let faktor = (breite * hoehe) / 1_000_000;

    // Mindestabnahme: 1 qm
    faktor = Math.max(faktor, 1);

    const priceBase = appData.static.artikel.preise.fVKBrutto;
    const priceVariationWerte = sumAufpreise(appData);
    priceArtikel = (priceBase + priceVariationWerte) * faktor;
  } else if (appData.static.config.productType === 'stahlwelle'
    || appData.static.config.productType === 'lamelle'
    || appData.static.config.productType === 'fuehrungsschiene'
    || appData.static.config.productType === 'endleiste'
    || appData.static.config.productType === 'deckleiste') {
    const laenge = getLaenge(appData);
    const faktor = laenge / 1_000;
    const priceBase = appData.static.artikel.preise.fVKBrutto;
    const priceVariationWerte = sumAufpreise(appData);
    priceArtikel = (priceBase + priceVariationWerte) * faktor;
  } else if (appData.static.config.productType === 'insektenschutz') {
    const breite = getBreite(appData);
    const tiefe = getTiefe(appData);
    priceArtikel = calculatePrice(appData.static.priceTableNetto, tiefe, breite, Number(appData.static.artikel.preise.fUst));
  } else if (appData.static.config.productType === 'hochwasserschutz') {
    const kEigenschaftWert = appData.dynamic.selectedVariationWerte[appData.static.kEigenschaftStauhoehe];
    const stauhoehe = appData.static.kEigenschaftWertToValue[kEigenschaftWert];
    const breite = getBreite(appData);
    priceArtikel = calculatePrice(appData.static.priceTableNetto, breite, stauhoehe, Number(appData.static.artikel.preise.fUst));
  } else {
    throw Error(`Unknown product type: ${appData.static.config.productType}`);
  }

  const verstaerkung = getNullableSelectedVariationWert(
    appData.static.artikel,
    appData.dynamic.selectedVariationWerte,
    appData.static.kEigenschaftVerstaerkung
  );

  let price = priceArtikel + (verstaerkung?.fAufpreis[0] ?? 0);
  if (appData.static.kEigenschaftVersand) {
    const priceVersand = getSelectedVariationWert(
      appData.static.artikel,
      appData.dynamic.selectedVariationWerte,
      appData.static.kEigenschaftVersand
    ).fAufpreis[0];
    price += priceVersand;
  }
  const priceConfigured = (
    <div>
      <div className="price h1 ">
        <span itemProp="priceSpecification" itemType="https://schema.org/UnitPriceSpecification">
          {Number.isNaN(price)
            && (
              <span>- €</span>
            )}
          {!Number.isNaN(price)
            && (
              <Preis value={price} />
            )}
        </span>
      </div>
    </div>
  );

  return (
    <div className="price_wrapper mt-3">
      {Object.keys(appData.dynamic.selectedVariationWerte).length === 0 && priceStartingAt}
      {Object.keys(appData.dynamic.selectedVariationWerte).length > 0 && priceConfigured}
      <meta itemProp="minPrice" content={appData.static.artikel.preise.fVKBrutto.toFixed(2)} />
      <meta itemProp="maxPrice" content={(appData.static.artikel.preise.fVKBrutto * 6).toFixed(2)} />
      <meta itemProp="price" content={price.toFixed(2)} />
      <meta itemProp="priceCurrency" content="EUR" />
      <div className="price-note">
        <span className="vat_info">
          inkl. {Number(appData.static.artikel.preise.fUst)}% USt., zzgl. Versand
        </span>
      </div>
      {appData.static.config.productType !== 'hochwasserschutz'
        && appData.static.config.productType !== 'insektenschutz'
        && (
          <div>(Grundpreis: <UnsafeHtml unsafeHtml={appData.static.artikel.preise.cVKLocalized[0]} />
            {(appData.static.config.productType === 'stahlwelle'
              || appData.static.config.productType === 'lamelle'
              || appData.static.config.productType === 'fuehrungsschiene'
              || appData.static.config.productType === 'endleiste'
              || appData.static.config.productType === 'deckleiste') ? ' pro m' : ''}
            {appData.static.config.productType === 'rolladen' ? ' pro m²' : ''})
          </div>
        )}
    </div>
  );
}

export default Artikelpreis;
